import { Loader2 } from "lucide-react";
import { useLocation } from "react-router-dom";
import { lazy, Suspense } from "react";

// Lazy load skeleton components
const DashboardSkeleton = lazy(() => import("@/components/skeletons/DashboardSkeleton"));
const JournalSkeleton = lazy(() => import("@/components/skeletons/JournalSkeleton"));
const ProfileSkeleton = lazy(() => import("@/components/skeletons/ProfileSkeleton"));

const PageLoadingSpinner = () => {
  const location = useLocation();
  
  // Determine which skeleton to show based on route
  const getSkeletonComponent = () => {
    const path = location.pathname;
    
    if (path === '/dashboard' || path === '/') {
      return DashboardSkeleton;
    }
    if (path === '/journal' || path.startsWith('/entry/')) {
      return JournalSkeleton;
    }
    if (path === '/profile') {
      return ProfileSkeleton;
    }
    
    // Default loading spinner for other routes
    return null;
  };
  
  const SkeletonComponent = getSkeletonComponent();
  
  if (SkeletonComponent) {
    return (
      <Suspense fallback={<DefaultSpinner />}>
        <SkeletonComponent />
      </Suspense>
    );
  }
  
  return <DefaultSpinner />;
};

const DefaultSpinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-background">
    <div className="flex flex-col items-center gap-4 animate-in fade-in duration-300">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Loading...</p>
    </div>
  </div>
);

export default PageLoadingSpinner;
